"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from 'lucide-react';
export default function HeroLawnMowerService() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="1607" id="hero-lawn-mower-service" className="relative min-h-[90vh] w-full overflow-hidden flex items-center bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/lawn_mower_service_hero_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/lawn_mower_service_hero_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/lawn_mower_service_hero_bg.png-wvc-sizes" alt="Professional lawn mower servicing" className="h-full w-full object-cover" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/lawn_mower_hero.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/zac-gudakov-CQkBjIfJjwY-unsplash-1-scaled.png" src="https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-08.59.21.jpeg" src="https://intimate-prawn.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-16-at-09.03.58.jpeg" />
        <div className="absolute inset-0 bg-linear-to-r from-background/95 via-background/80 to-transparent" />
      </div>

      <div className="page-container relative z-10 py-24 !opacity-[1] lg:py-32">
        <div ref={contentRef} className={`max-w-3xl transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <div className="inline-flex items-center gap-3 mb-8">
            
            
          </div>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.05] text-foreground mb-8"><span className="text-primary italic" data-ast-id="f:/src/pages/LawnMowerServicingRepairsInCarlisleCumbria/sections/HeroLawnMowerService.tsx|sig:55x7uv" data-ast-start="2035" data-ast-end="2100"><font color="#1a2e20" data-ast-id="f:/src/pages/LawnMowerServicingRepairsInCarlisleCumbria/sections/HeroLawnMowerService.tsx|sig:m6wyxb" data-ast-start="2183" data-ast-end="2660"><span data-ast-id="f:/src/pages/LawnMowerServicingRepairsInCarlisleCumbria/sections/HeroLawnMowerService.tsx|sig:i1um2m" data-ast-start="2362" data-ast-end="2653" style={{
                fontStyle: 'normal'
              }} contenteditable="false" className="!text-[rgba(0,0,0,1)]">Lawn Mower Servicing & Repairs In Carlise </span></font></span></h1>

          <p className="max-w-xl text-lg font-normal leading-relaxed mb-12 !text-[rgba(15,23,41,1)] md:text-xl">
            Professional lawn mower servicing and repairs in Carlisle. From domestic push mowers to commercial ride-ons, our expert engineers ensure your equipment performs at its peak all season long.
          </p>

          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg" className="rounded-lg px-8 py-7 text-lg font-semibold shadow-lg hover:shadow-primary/20 transition-all hover:scale-[1.02] active:scale-[0.98]">
              <Link to="#contact">
                Book a Service
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="rounded-lg px-8 py-7 text-lg font-semibold border-2 hover:bg-accent transition-all hover:scale-[1.02] active:scale-[0.98]">
              <Link to="/LawnMowerServicingRepairsInCarlisleCumbriaPage">
                Our Repair Services
              </Link>
            </Button>
          </div>

          
        </div>
      </div>
    </section>;
}